import generic_backend_request_post from 'functions/server/generic_backend_request_post';
import CostMatrixRequest from 'open-api-gen/model/CostMatrixRequest.js';
import getLocations, { getTravelCosts, getCostSettings } from 'store/functions/openapi_conversion_functions';
import { isCartesian } from 'store/functions/coordinateSystem.js';
import { computePlanarCostMatrix } from 'store/functions/planarCosts.js';


async function get_cost_matrix(state, options = {}) {
    /**
     * This function sends a request to the backend server to get a cost matrix.
     * It constructs the request body using the locations and cost settings from the state.
     * It returns the response from the backend server.
     */
    if (!state.data) {
        throw new Error('Expecting data in state');
    }
    if (!state.data.locations) {
        throw new Error('Expecting location data in state.data.locations');
    }
    if (!state.generalSettings) {
        throw new Error('Expecting generalSettings in state.generalSettings');
    }
    if (!state.generalSettings.costs) {
        throw new Error('Expecting cost settings in state.generalSettings.costs');
    }

    // Cartesian scenarios never reach the backend: every /cost_matrix method
    // (driving, haversine, geographic manhattan) is lat/lng-based. Compute the
    // planar matrix locally and return it in the same CostMatrixResponse
    // shape, so the fetchTravelCosts reducer and UI work unchanged.
    if (isCartesian(state)) {
        const method = state.generalSettings.costs.distanceMethod;
        return computePlanarCostMatrix({
            locations: state.data.locations,
            metric: method === 'manhattan' ? 'manhattan' : 'euclidean',
            costMetric: state.generalSettings.costs.costMetric,
            averageSpeed: state.generalSettings.costs.averageSpeed,
            roadCircuityFactor: state.generalSettings.costs.roadCircuityFactor,
        });
    }

    const locations = getLocations(state);
    const travelCosts = getTravelCosts(state);
    const reqCostSettings = getCostSettings(state, { roadNetworkAllowed: options.roadNetworkAllowed });

    const reqCostMatrix = CostMatrixRequest.constructFromObject({
        locations: locations,
        costSettings: reqCostSettings,
        travelCosts: travelCosts
    });
  
    const response = await generic_backend_request_post(reqCostMatrix, '/cost_matrix');
    return response;
}

export default get_cost_matrix